"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CircleStatusIcon;
var _material = require("@mui/material");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function CircleStatusIcon({
  svgProps,
  ...rest
}) {
  const color = (0, _utils.getColor)(rest);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.SvgIcon, {
    ...svgProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      fill: color,
      cx: "12",
      cy: "12",
      r: "12"
    })
  });
}